import React from 'react';
export default function OpponentsTurnInstruction() {
    return React.createElement("p", null, "Wait until your opponent finishes his turn.");
}
